"use client";

import React from "react";
import { useDialogStore } from "@/store/dialogStore";
import Toast from "./Toast";

const ToastContainer: React.FC = () => {
  const toasts = useDialogStore((state) => state.toasts);
  const removeToast = useDialogStore((state) => state.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[60] flex flex-col gap-2 w-[380px] max-w-[90vw] pointer-events-none">
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            id={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onDismiss={removeToast}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
